import {createSlice, createAsyncThunk, PayloadAction} from "@reduxjs/toolkit";
import {Role, Api} from "types/models";
import {catalogService} from "api";
export interface State {
  idPhieu: number | string;
  idReceipt: number | string;
  listThuocTraMat: any[];
  allListThuocTraMat: any[];
  listLichSuTra: any[];
  detailPhieu: any;
  statusTraThuoc: any;
  callApiList: boolean;
}

const initialState: State = {
  idPhieu: null,
  listThuocTraMat: [],
  allListThuocTraMat: [],
  detailPhieu: null,
  listLichSuTra: [],
  idReceipt: null,
  statusTraThuoc: null,
  callApiList: false,
};

export const nurseOutSlice = createSlice({
  name: "nurseOut",
  initialState: initialState,
  reducers: {
    setIdPhieu: (state = initialState, action: PayloadAction<any>) => {
      return {...state, idPhieu: action.payload};
    },
    setIdReceiptNurseOut: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      return {...state, idReceipt: action.payload};
    },
    setlistThuocTraMat: (state = initialState, action: PayloadAction<any>) => {
      return {...state, listThuocTraMat: action.payload};
    },
    setAllListThuocTraMat: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      return {...state, allListThuocTraMat: action.payload};
    },
    setDetailPhieu: (state = initialState, action: PayloadAction<any>) => {
      return {...state, detailPhieu: action.payload};
    },
    setListLichSuTra: (state = initialState, action: PayloadAction<any>) => {
      return {...state, listLichSuTra: action.payload};
    },
    setStatusTraThuoc: (state = initialState, action: PayloadAction<any>) => {
      return {...state, statusTraThuoc: action.payload};
    },
    setCallApiList: (state = initialState, action: PayloadAction<any>) => {
      return {...state, callApiList: action.payload};
    },
  },
});

export const {
  setIdPhieu,
  setlistThuocTraMat,
  setAllListThuocTraMat,
  setDetailPhieu,
  setListLichSuTra,
  setIdReceiptNurseOut,
  setStatusTraThuoc,
  setCallApiList,
} = nurseOutSlice.actions;

export default nurseOutSlice.reducer;
export const getListLichsuTraThuocAPI = idPhieu => {
  return async dispatch => {
    try {
      const res = (await catalogService.getListLichsuTraThuoc(idPhieu)) || [];
      dispatch(setListLichSuTra(res));
    } catch (error) {}
  };
};

export const getAllListDilate = () => {
  return async dispatch => {
    try {
      const res = (await catalogService.getAllListDilate()) || [];
      dispatch(setAllListThuocTraMat(res));
    } catch (error) {}
  };
};
